import React from 'react';
import I18n from 'i18n-js';

import Modal from '@reverbdotcom/commons/src/components/modal';
import { MParticleEventName, trackEvent } from '@reverbdotcom/commons/src/elog/mparticle_tracker';
import { useViewTracking } from '@reverbdotcom/commons/src/use_tracking';

import Item2ShippingPrompt from './item2_shipping_prompt';
import { Listing } from '@reverbdotcom/commons/src/gql/graphql';

interface IExternalProps {
  showModal: boolean;
  listing: Listing;
}

type IProps = IExternalProps;

export default function Item2ShippingPromptModal({
  listing,
  showModal,
}: IProps) {
  const [isOpen, setIsOpen] = React.useState(showModal);

  function closeModal() {
    trackEvent({
      eventName: MParticleEventName.DismissedShippingPromptModal,
      listingId: listing.id,
    });

    setIsOpen(false);
  }

  useViewTracking({
    componentName: 'Item2ShippingPromptModal',
    eventName: MParticleEventName.ComponentView,
    listingId: listing.id,
  }, isOpen);

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={closeModal}
      headerTitle={I18n.t('discovery.item2ShippingPrompt.title')}
      paddedBody
    >
      <Item2ShippingPrompt
        listing={listing}
      />
    </Modal>
  );
}
